// Simple process polyfill for browser
// This is needed because @fartherfinance/frontend uses process.env with bracket notation
// which webpack's DefinePlugin cannot replace

module.exports = {
  get env() {
    return typeof window !== "undefined"
      ? window.__WEBPACK_PROCESS_ENV__ || {}
      : {};
  },
};
